"use strict";
/**
 * Created by emil.saghatelyan on 12/15/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var CategoryPermissionType;
(function (CategoryPermissionType) {
    CategoryPermissionType[CategoryPermissionType["ADD"] = 1] = "ADD";
    CategoryPermissionType[CategoryPermissionType["EDIT"] = 2] = "EDIT";
    CategoryPermissionType[CategoryPermissionType["VIEW"] = 3] = "VIEW";
    CategoryPermissionType[CategoryPermissionType["DELETE"] = 4] = "DELETE";
})(CategoryPermissionType = exports.CategoryPermissionType || (exports.CategoryPermissionType = {}));
//# sourceMappingURL=category-permission-type.js.map